import React, { useRef } from 'react';
import {
  TextField,
  ReferenceField,
  useRefresh,
  FunctionField,
  BooleanField,
  Datagrid,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

import AlarmAddIcon from '@material-ui/icons/AlarmAdd';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PrintIcon from '@material-ui/icons/Print';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import { DialogoConfirmacao } from '../../Components';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageTabbedComBuscaPagina from '../../Components/ReactAdmin/List/ListPageTabbedComBuscaPagina';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import {
  api,
  imprimirChecklistColaboradorPuro,
  imprimirContraProva,
} from '../../services';
import {
  STATUS_ATIVO,
  STATUS_INATIVO,
  TURNO_MANHA,
  TURNO_NOITE,
  TURNO_12_HORAS,
} from '../../utils/constants';
//import ActionsField from './ActionsField';
import { PERMISSAO_TELA_COLABORADORES_LISTAR } from '../../utils/dadosTelas';
import DialogoAtivarColaborador from './DialogoAtivarColaborador';
import Dialogo from './DialogoCreateEdit';
import DialogoDeleteResource from './DialogoDeletar';
import DialogoHorarios from './DialogoHorarios';
import DialogoShow from './DialogoShow';
import { choicesTurno } from './Filter';

const tabs = [
  { id: 'ativos', name: 'Ativos', filter: { status: STATUS_ATIVO } },
  { id: 'inativos', name: 'Inativos', filter: { status: STATUS_INATIVO } },
];

// Mesmos filtros de Filter.js, no formato do drawer "Filtros avançados". "Nome" virou a
// busca rápida do cabeçalho; os switches ficam por último (o drawer os agrupa).
const advancedFilters = [
  <ReferenceInput
    fullWidth
    label="Função"
    source="funcao_colaborador_id"
    reference="funcoes_colaboradores"
    allowEmpty={false}
    filter={{ status: STATUS_ATIVO }}
  >
    <SelectInput optionText="nome" allowEmpty={false} />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Local"
    source="local_id"
    reference="locais_setores"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    perPage={30}
    filter={{ status: STATUS_ATIVO }}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Grupo"
    source="grupo_colaborador_id"
    reference="grupos_colaborador"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    perPage={30}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <SelectInput
    fullWidth
    label="Turno"
    source="turno"
    choices={choicesTurno}
    allowEmpty={false}
  />,
  <BooleanInput label="É Usuário" source="is_user" />,
  <BooleanInput label="É Gestor" source="is_gestor" />,
  <BooleanInput label="Funcionário Interno" source="is_funcionario_interno" />,
];

const optionsTurno = {
  [TURNO_MANHA]: 'Manhã',
  [TURNO_NOITE]: 'Noite',
  [TURNO_12_HORAS]: '12H',
};

//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);
  const refDialogoShow = useRef(null);
  const refDialogoConfirmacao = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  const refDialogoHorarios = useRef(null);
  const refDialogoAtivarColaborador = useRef(null);

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }

  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }

  function handleShow({ id }) {
    if (refDialogoShow.current) {
      refDialogoShow.current.handleOpen(id);
    }
  }

  function handleAtivar({ id }) {
    /*if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Colaborador',
        'Deseja realmente reativar este colaborador?',
        { id, codigo: 1 },
      );
    }*/
    if (refDialogoAtivarColaborador.current) {
      refDialogoAtivarColaborador.current.handleOpen(id);
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Colaborador',
        'Deseja realmente desativar este colaborador?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Colaborador',
        'Deseja deletar permanentemente este colaborador?',
        { id, codigo: 3 },
      );
    }
  }

  /*async function ativar(id) {
    await api.put(`/colaboradores/status/ativar/${id}`);
    handleClose();
  }*/

  async function ativar(id) {
    try {
      const response = await api.put(`/colaboradores/status/ativar/${id}`);
      const { status, message, data } = response.data;
      if (!status) throw message;
      else {
        enqueueSnackbar(`Colaborador ativado com sucesso!`, {
          variant: 'success',
        });
      }
      handleClose();
    } catch (e) {
      enqueueSnackbar(`${e}`, {
        variant: 'error',
      });
    }
  }

  async function desativar(id) {
    try {
      const response = await api.put(`/colaboradores/status/inativar/${id}`);
      const { status, message, data } = response.data;
      if (!status) throw message;
      else {
        enqueueSnackbar(`Colaborador inativado com sucesso!`, {
          variant: 'success',
        });
      }
      handleClose();
    } catch (e) {
      enqueueSnackbar(`${e}`, {
        variant: 'error',
      });
    }
  }

  /*async function deletar(id) {
    await api.put(`/colaboradores/status/deletar/${id}`);
    handleClose();
  }*/

  async function deletar(id) {
    try {
      const response = await api.put(`/colaboradores/status/deletar/${id}`);
      const { status, message, data } = response.data;
      if (!status) throw message;
      else {
        enqueueSnackbar(`Colaborador deletado com sucesso!`, {
          variant: 'success',
        });
      }
      handleClose();
    } catch (e) {
      enqueueSnackbar(`${e}`, {
        variant: 'error',
      });
    }
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  function handleClose() {
    refresh();
  }

  function handleHorarios({ id }) {
    if (refDialogoHorarios.current) {
      refDialogoHorarios.current.handleOpen(id);
    }
  }

  async function handleImprimir({ id }) {
    const codigo = await imprimirChecklistColaboradorPuro(id);
    if (codigo < 0) {
      enqueueSnackbar('Erro ao imprimir o checklist!', {
        variant: 'error',
      });
    }
  }

  async function handleImprimirContraProva({ id }) {
    const response = await api.get(`/ultimo_ponto_colaborador/${id}`);
    if (response.data.id) {
      const codigo = await imprimirContraProva(response.data.id);
      if (codigo < 0) {
        enqueueSnackbar(
          'Erro ao imprimir a última contraprova deste colaborador!',
          {
            variant: 'error',
          },
        );
      }
    } else {
      enqueueSnackbar('Erro ao encontrar este ponto!', {
        variant: 'error',
      });
    }
  }

  return (
    <>
      <ListPageTabbedComBuscaPagina
        title="Colaboradores"
        itemLabelPlural="colaboradores"
        perPage={50}
        rowsPerPageOptions={[10, 25, 50, 100]}
        modoRolagemTabela="setas"
        colunasFixadasIniciais={{ nome: 'esquerda', acoes: 'direita' }}
        larguraFixadaEsquerda={300}
        larguraFixadaDireita={190}
        tabs={tabs}
        advancedFilters={advancedFilters}
        quickFilterSource="nome"
        quickFilterLabel="Nome"
        quickFilterPlaceholder="Buscar por nome..."
        onCreate={handleCriar}
        createLabel="Novo"
        listProps={{
          basePath: props.basePath,
          resource: props.resource,
          sort: { field: 'nome', order: 'ASC' },
          filterDefaultValues: { status: STATUS_ATIVO },
        }}
      >
        <Datagrid>
          <TextField source="id" label="ID" />
          <TextField source="nome" label="Nome" />
          <ReferenceField
            label="Usuário"
            source="user_id"
            reference="users"
            sortable={false}
            linkType={false}
          >
            <TextField source="username" />
          </ReferenceField>
          <ReferenceField
            label="Função"
            source="funcao_colaborador_id"
            reference="funcoes_colaboradores"
            sortable={false}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <ReferenceField
            label="Grupo"
            source="grupo_colaborador_id"
            reference="grupos_colaborador"
            sortable={false}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <ReferenceField
            label="Codinome"
            source="codinome_colaborador_id"
            reference="codinomes_colaborador"
            sortable={false}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <ReferenceField
            label="Loja"
            source="empresa_id"
            reference="empresa-loja"
            sortable={false}
            linkType={false}
          >
            <TextField source="nome_fantasia" />
          </ReferenceField>
          <FunctionField
            source="turno"
            label="Turno"
            render={(record) => optionsTurno[record.turno]}
          />
          <BooleanField source="is_gestor" label="Gestor" />
          <BooleanField
            label="Funcionário Interno"
            source="is_funcionario_interno"
          />
          <ActionsField
            source="acoes"
            textAlign="right"
            label="Ações"
            sortable={false}
            maxAcoesVisiveis={3}
            actions={[
              {
                key: 'edit',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: handleEdit,
                show: (rec) => rec.status === STATUS_ATIVO,
                disabled: () => false,
              },
              {
                key: 'show',
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: handleShow,
                show: () => true,
                disabled: () => false,
              },
              {
                key: 'ativar',
                title: 'Ativar',
                icon: <CheckCircleOutlineIcon />,
                onClick: handleAtivar,
                show: (rec) => rec.status === STATUS_INATIVO,
                disabled: (rec) => !rec.user_id,
              },
              {
                key: 'horarios',
                title: 'Horários',
                icon: <AlarmAddIcon />,
                onClick: handleHorarios,
                show: (rec) => rec.status === STATUS_ATIVO,
                disabled: () => false,
              },
              {
                key: 'printChecklist',
                title: 'Imprimir Checklist',
                icon: <AssignmentIcon />,
                onClick: handleImprimir,
                show: (rec) => rec.status === STATUS_ATIVO,
                disabled: () => false,
              },
              {
                key: 'printContraProva',
                title: 'Imprimir Última Contraprova',
                icon: <PrintIcon style={{ color: 'green' }} />,
                onClick: handleImprimirContraProva,
                show: (rec) => rec.status === STATUS_ATIVO,
                disabled: () => false,
              },
              {
                key: 'desativar',
                title: 'Desativar',
                icon: <ClearIcon />,
                onClick: handleDesativar,
                show: (rec) => rec.status === STATUS_ATIVO,
                disabled: () => false,
              },
              {
                key: 'delete',
                title: 'Excluir',
                icon: <DeleteOutlineIcon />,
                onClick: handleDeletar,
                show: (rec) => rec.status === STATUS_INATIVO,
                disabled: () => false,
              },
            ]}
          />
        </Datagrid>
      </ListPageTabbedComBuscaPagina>
      <Dialogo ref={refDialogoCompra} handleClose={handleClose} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
      <DialogoShow ref={refDialogoShow} handleClose={handleClose} />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
      <DialogoHorarios ref={refDialogoHorarios} />
      <DialogoAtivarColaborador
        ref={refDialogoAtivarColaborador}
        handleClose={handleClose}
      />
    </>
  );
};

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_COLABORADORES_LISTAR}>
    <MyList {...props} />
  </ProtegerPagina>
);

export default List2;
